/** Figma `_Tabs/Tab`(8:87) · `Tabs`(39:1931)의 축 */
export type TabSize = 'md' | 'sm';
export type TabsStatus = 'default' | 'init' | 'loading';

export const TAB_SIZES: readonly TabSize[] = ['md', 'sm'];

/** 높이 · 좌우 여백: md 40 · 16(구획 탭), sm 28 · 4(그래프 카드의 기간 탭) */
export const TAB_SIZE_CLASS: Record<TabSize, string> = {
  md: 'h-(--size-control-md) px-4',
  sm: 'h-(--size-control-xs) px-1',
};

/** 선택된 탭: primary 굵은 글자 + 아래 2px primary 선 */
export const TAB_ACTIVE_CLASS: Record<TabSize, string> = {
  md: 'border-b-2 border-border-primary text-fg-primary typo-body-sm-strong',
  sm: 'border-b-2 border-border-primary text-fg-primary typo-body-sm-strong',
};

/** 선택되지 않은 탭: 회색 글자(md 보통 · sm 굵게) + 아래 1px 옅은 선 */
export const TAB_INACTIVE_CLASS: Record<TabSize, string> = {
  md: 'border-b border-border-subtle text-fg-muted typo-body-sm',
  sm: 'border-b border-border-subtle text-fg-muted typo-body-sm-strong',
};
